import { AnimatePresence } from 'framer-motion';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';

import type { LandingPageScrollFeatureTabProps } from './LandingPageScrollFeatureTabs';

interface LandingPageScrollFeatureImageProps {
  readonly activeTab: number;
  readonly tabs: Pick<LandingPageScrollFeatureTabProps, 'image' | 'imageAlt'>[];
}

const LandingPageScrollFeatureImages = ({
  activeTab,
  tabs,
}: LandingPageScrollFeatureImageProps) => {
  return (
    <section>
      {tabs.map((tab, index) => (
        <div key={`tab-${index}-${tab.imageAlt}`} className="relative">
          <AnimatePresence mode="popLayout">
            {index === activeTab && (
              <Motion
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
              >
                <Image
                  src={tab.image}
                  localizedAlt={tab.imageAlt}
                  width={417}
                  height={674}
                />
              </Motion>
            )}
          </AnimatePresence>
        </div>
      ))}
    </section>
  );
};

export default LandingPageScrollFeatureImages;
